import { Modal } from "@/components/ui/Modal";
import { Kbd } from "@/components/ui/Button";

interface Props {
  open: boolean;
  onClose: () => void;
}

interface Shortcut {
  keys: string[];
  label: string;
}

const groups: { name: string; items: Shortcut[] }[] = [
  {
    name: "Navigation",
    items: [
      { keys: ["g", "h"], label: "Go to dashboard" },
      { keys: ["g", "m"], label: "Go to movies" },
      { keys: ["g", "t"], label: "Go to TV" },
      { keys: ["g", "a"], label: "Go to artists" },
      { keys: ["g", "i"], label: "Go to indexers" },
    ],
  },
  {
    name: "Actions",
    items: [
      { keys: ["⌘", "K"], label: "Open command palette" },
      { keys: ["/"], label: "Focus search" },
      { keys: ["?"], label: "Show this cheatsheet" },
      { keys: ["Esc"], label: "Close dialog" },
    ],
  },
];

export function ShortcutsCheatsheet({ open, onClose }: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Keyboard shortcuts"
      eyebrow="Reference"
      width="md"
    >
      <div className="space-y-6">
        {groups.map((group) => (
          <section key={group.name}>
            <h3 className="eyebrow mb-3">{group.name}</h3>
            <ul className="divide-y divide-line/60 rounded-md border border-line bg-surface/30">
              {group.items.map((s) => (
                <li
                  key={s.keys.join("+") + s.label}
                  className="flex items-center justify-between px-3 py-2 text-sm"
                >
                  <span className="text-foreground/85">{s.label}</span>
                  <span className="flex items-center gap-1">
                    {s.keys.map((k, i) => (
                      <span key={i} className="flex items-center gap-1">
                        <Kbd>{k}</Kbd>
                        {i < s.keys.length - 1 &&
                          (s.keys[0] === "g" ? (
                            <span className="text-[10px] text-foreground/40">
                              then
                            </span>
                          ) : null)}
                      </span>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        ))}
        <p className="text-xs text-foreground/45">
          Sequences (e.g. <Kbd>g</Kbd> <Kbd>m</Kbd>) require pressing the second
          key within ~1 second of the first.
        </p>
      </div>
    </Modal>
  );
}
